function NRDragHandleIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(9, 4)">
        <path d="M6 16L6 0L4 -8.74228e-08L4 16L6 16ZM0 -2.62268e-07L-6.99382e-07 16L2 16L2 -1.74846e-07L0 -2.62268e-07Z" fill={color} />
      </g>
    </svg>
  );
}

export default NRDragHandleIcon;
